import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import Actions from 'flow/actions';
import { getBrand } from 'flow/brands/brands';
import { electronActions, electronListeners } from 'flow/utils/electron-utils';
import { signIn, clearLoginData, setPreventUnload, noPassword, checkVersion, updateLangConstants, updateApplicationState, setAutoLoginWithAccessToken } from 'flow/actions/app-actions';
import { unregisterTopConnection } from 'flow/actions/top-actions';
import { startExternalSignIn, cancelExternalSignIn, startTeamsMicrosoftSignIn } from 'flow/actions/social-integration-actions';
import SignInForm from 'flow/components/SignInForm';
import { getTelavoxFormattedLanguageCode, isEmptyNullOrUndefined } from 'flow/utils';
import { getApplicationLanguage, getAutoLogin, setAutoLogin } from 'flow/utils/browser-utils';
import { createReturnUrl } from 'flow/utils/social-integration-utils';
import { getAllowedVersion } from 'flow/selectors/selectors';
import Loading from 'flow/components/ui-components/Loading';
import AppContext from 'flow/contexts/app-context';
import { hasTooManyInstances } from 'flow/selectors/cti-integration-selectors';
import { cancelCtiExternalSignIn, startCtiGoogleSignIn, startCtiMicrosoftSignIn, startCtiOidcSignIn } from 'flow/route-components/cti-sso';
import { isEmbeddedTypeCti, isTeamsFullClient } from 'flow/utils/app-utils';
import { MSGOO_APP_REG_DEFAULT_VALUE } from 'flow/utils/social-integration-utils';
import { SYNC_SOURCE } from 'flow/utils/constants/app-constants';
import isElectron from 'is-electron';
import appConfig from 'app-config';
import { isUaePassEnabled } from 'flow/constants/uae-pass/uae-pass-constants';
import { revealDesktopWindow } from 'flow/companion/companion-window';

/**
 * NOTE: This component is intended to be used as the login page for Electron
 * To sign in from the web, use the https://${getBrand().brandAdminUrl}/flowin.jsp page
 */
import { jsx as _jsx } from "react/jsx-runtime";
var SignIn = /*#__PURE__*/function (_React$PureComponent) {
  function SignIn(props, context) {
    var _this;
    _classCallCheck(this, SignIn);
    _this = _callSuper(this, SignIn, [props]);
    /**
     * Reaching the sign-in form means a hidden companion cannot look after itself - no saved
     * credentials, "remember me" off, an expired token, a refusal - and would otherwise sit there
     * running, signed out and invisible.
     *
     * Hung off the same condition as the render, so it cannot disagree with what is on screen.
     * Once only, so signing out and back in does not keep pulling the window forward.
     */
    _defineProperty(_this, "revealWindowWhenSignInNeedsAPerson", function () {
      if (_this.hasRevealedForSignIn) {
        return;
      }
      var _this$state = _this.state,
        autoSigningIn = _this$state.autoSigningIn,
        isLoginLoading = _this$state.isLoginLoading;
      if (autoSigningIn || isLoginLoading) {
        return;
      }
      _this.hasRevealedForSignIn = true;
      revealDesktopWindow('sign-in needs the user');
    });
    _defineProperty(_this, "onSuccessfulSignIn", function (username, password) {
      _this.setState({
        isLoginLoading: false
      });
      if (isElectron()) {
        setAutoLogin(true);
        electronActions.saveUserCredentials(username, password);
      } else {
        setAutoLogin(false);
      }
    });
    _defineProperty(_this, "onUsernameChanged", function (username) {
      var savedUsername = _this.state.savedUsername;
      if (savedUsername && username !== savedUsername) {
        electronActions.deleteUserCredentials();
        setAutoLogin(false);
        _this.setState({
          username: username,
          password: '',
          savedUsername: null
        });
      } else {
        _this.setState({
          username: username
        });
      }
    });
    _defineProperty(_this, "onPasswordChanged", function (password) {
      _this.setState({
        password: password
      });
    });
    _defineProperty(_this, "onUsernameOtherChanged", function (usernameOther) {
      _this.setState({
        usernameOther: usernameOther
      });
    });
    _defineProperty(_this, "setShowOtherSignInForm", function (showOtherSignInForm) {
      _this.setState({
        showOtherSignInForm: showOtherSignInForm
      });
    });
    _defineProperty(_this, "setEnabledOidcSignIn", function (enabledOidcSignIn) {
      _this.setState({
        enabledOidcSignIn: enabledOidcSignIn
      });
    });
    _defineProperty(_this, "onSignInError", function (error) {
      if (error.loginFail) {
        setAutoLogin(false);
        if (error !== null && error !== void 0 && error.accessToken) {
          electronActions.deleteIntegrationToken();
        } else {
          electronActions.deleteSavedUserName();
        }
      }
      _this.setState({
        autoSigningIn: false,
        isLoginLoading: false
      });
      _this.resetPasswordOnError(error);
    });
    _defineProperty(_this, "resetPasswordOnError", function (error) {
      if (error && error.loginFail) {
        _this.setState({
          password: ''
        });
      }
    });
    _defineProperty(_this, "signInWithToken", function (accessToken) {
      var dispatch = _this.props.dispatch;
      if (accessToken) {
        dispatch(signIn(null, null, function () {
          setAutoLogin(true);
          _this.setState({
            isLoginLoading: false
          });
        }, _this.onSignInError, accessToken));
      } else {
        electronActions.deleteIntegrationToken();
      }
    });
    _defineProperty(_this, "signIn", function (username, password) {
      var dispatch = _this.props.dispatch;
      if (password) {
        dispatch(signIn(username, password, function () {
          dispatch(updateApplicationState('boot'));
          return _this.onSuccessfulSignIn(username, password);
        }, _this.onSignInError));
      } else {
        dispatch(noPassword());
      }
    });
    _defineProperty(_this, "handleSignIn", function (username, password) {
      _this.signIn(username, password);
    });
    _defineProperty(_this, "startGoogleSignIn", function () {
      _this.startExternalSignIn(SYNC_SOURCE.google, MSGOO_APP_REG_DEFAULT_VALUE);
    });
    _defineProperty(_this, "startMicrosoftSignIn", function () {
      _this.startExternalSignIn(SYNC_SOURCE.microsoft, MSGOO_APP_REG_DEFAULT_VALUE);
    });
    _defineProperty(_this, "startTeamsMicrosoftSignIn", function () {
      _this.props.dispatch(startTeamsMicrosoftSignIn());
    });
    _defineProperty(_this, "getMicrosoftSignIn", function (isTeamsEmbedded) {
      return isTeamsEmbedded ? _this.startTeamsMicrosoftSignIn : _this.startMicrosoftSignIn;
    });
    _defineProperty(_this, "startOidcSignIn", function (appRegistrationId) {
      _this.startExternalSignIn(SYNC_SOURCE.oidc, appRegistrationId);
    });
    _defineProperty(_this, "startExternalSignIn", function (syncSource, appRegId) {
      var dispatch = _this.props.dispatch;
      electronListeners.checkIfExternalSignInFinished(dispatch);
      var callbackUrl = createReturnUrl('dummy', syncSource);
      dispatch(startExternalSignIn(syncSource, callbackUrl, appRegId));
    });
    _defineProperty(_this, "cancelExternalSignIn", function () {
      var dispatch = _this.props.dispatch;
      dispatch(cancelExternalSignIn());
    });
    _defineProperty(_this, "receiveExternalSigninData", function (data) {
      return {
        type: Actions.APP_EXTERNAL_SIGNIN_DATA,
        data: data
      };
    });
    _defineProperty(_this, "onLinkClick", function () {
      setPreventUnload(true);
    });
    _defineProperty(_this, "onLanguageChange", function (languageCode) {
      var adjustedLanguageCode = getTelavoxFormattedLanguageCode(languageCode);
      _this.setState({
        userLanguage: updateLangConstants(adjustedLanguageCode)
      });
    });
    _defineProperty(_this, "getPasswordForgottenUrl", function () {
      var passwordActionUrl = getBrand().passwordActionUrl;
      if (!passwordActionUrl) {
        return null; // Return null when password reset is not available
      }
      return "".concat(passwordActionUrl, "/signin.jsp?pwreset");
    });
    _this.state = {
      username: '',
      password: '',
      savedUsername: null,
      showOtherSignInForm: false,
      enabledOidcSignIn: true,
      usernameOther: '',
      userLanguage: getApplicationLanguage() || getTelavoxFormattedLanguageCode(context.i18next.language) || 'en',
      autoSigningIn: false,
      isLoginLoading: true
    };
    _this.hasRevealedForSignIn = false;
    updateLangConstants(_this.state.userLanguage);

    // Check version if NO_UPDATE
    if (process.env.NO_UPDATE === 'true') {
      _this.props.dispatch(checkVersion());
    }
    if (!isElectron()) {
      _this.setState({
        isLoginLoading: false
      });
    }
    return _this;
  }
  _inherits(SignIn, _React$PureComponent);
  return _createClass(SignIn, [{
    key: "onAutoLoginProcess",
    value: function () {
      var _onAutoLoginProcess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var credentials, username, password, rememberCredentials, _ref, savedIAToken, savedIATokenId, _t, _t2;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return electronActions.getUserCredentials();
            case 1:
              credentials = _context.sent;
              if (!credentials) {
                _context.next = 2;
                break;
              }
              username = credentials.get('username');
              password = credentials.get('password');
              rememberCredentials = !isEmptyNullOrUndefined(username) || !isEmptyNullOrUndefined(password);
              this.setState({
                password: password,
                username: username,
                savedUsername: username
              });
              if (getAutoLogin() && rememberCredentials) {
                this.signIn(username, password);
                this.setState({
                  autoSigningIn: true,
                  isLoginLoading: false
                });
              } else {
                this.setState({
                  autoSigningIn: false,
                  isLoginLoading: false
                });
              }
              _context.next = 7;
              break;
            case 2:
              _context.next = 3;
              return electronActions.getIntegrationToken();
            case 3:
              _t = _context.sent;
              if (_t) {
                _context.next = 4;
                break;
              }
              _t = {};
            case 4:
              _ref = _t;
              savedIAToken = _ref.savedIAToken;
              savedIATokenId = _ref.savedIATokenId;
              if (!(savedIAToken && !getAutoLogin())) {
                _context.next = 6;
                break;
              }
              _context.next = 5;
              return electronActions.deleteIntegrationToken();
            case 5:
              this.setState({
                isLoginLoading: false
              });
              return _context.abrupt("return");
            case 6:
              this.props.dispatch(setAutoLoginWithAccessToken(savedIATokenId));
              if (savedIAToken) {
                this.signInWithToken(savedIAToken);
              } else {
                this.setState({
                  isLoginLoading: false
                });
              }
            case 7:
              _context.next = 9;
              break;
            case 8:
              _context.prev = 8;
              _t2 = _context["catch"](0);
              console.error('Auto-login process failed:', _t2);
              this.setState({
                isLoginLoading: false,
                autoSigningIn: false
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 8]]);
      }));
      function onAutoLoginProcess() {
        return _onAutoLoginProcess.apply(this, arguments);
      }
      return onAutoLoginProcess;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.props.dispatch(unregisterTopConnection);
              this.props.dispatch(clearLoginData);
              if (!(!appConfig.dev && isElectron() && !isUaePassEnabled)) {
                _context2.next = 2;
                break;
              }
              _context2.next = 1;
              return this.onAutoLoginProcess();
            case 1:
              _context2.next = 3;
              break;
            case 2:
              this.setState({
                isLoginLoading: false
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.dispatch(unregisterTopConnection);
      this.revealWindowWhenSignInNeedsAPerson();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        loginData = _this$props.loginData,
        externalSigninData = _this$props.externalSigninData,
        allowedVersion = _this$props.allowedVersion,
        tooManyInstances = _this$props.tooManyInstances;
      var _this$state2 = this.state,
        username = _this$state2.username,
        password = _this$state2.password,
        showOtherSignInForm = _this$state2.showOtherSignInForm,
        enabledOidcSignIn = _this$state2.enabledOidcSignIn,
        usernameOther = _this$state2.usernameOther,
        userLanguage = _this$state2.userLanguage,
        autoSigningIn = _this$state2.autoSigningIn,
        isLoginLoading = _this$state2.isLoginLoading;
      var isCtiEmbedded = isEmbeddedTypeCti(this.context.embedded);
      var isTeamsEmbedded = isTeamsFullClient(this.context.embedded);
      if (autoSigningIn || isLoginLoading) {
        return /*#__PURE__*/_jsx(Loading, {});
      }
      var signInProps = {
        password: password,
        username: username,
        usernameOther: usernameOther,
        onUsernameChanged: this.onUsernameChanged,
        onPasswordChanged: this.onPasswordChanged,
        onUsernameOtherChanged: this.onUsernameOtherChanged,
        setShowOtherSignInForm: this.setShowOtherSignInForm,
        setEnabledOidcSignIn: this.setEnabledOidcSignIn,
        handleSignIn: this.handleSignIn,
        loginData: loginData,
        externalSigninData: externalSigninData,
        onLinkClick: this.onLinkClick,
        onLanguageChange: this.onLanguageChange,
        userLanguage: userLanguage,
        passwordUrl: this.getPasswordForgottenUrl(),
        allowedVersion: allowedVersion,
        showOtherSignInForm: showOtherSignInForm,
        enabledOidcSignIn: enabledOidcSignIn,
        tooManyInstances: tooManyInstances,
        isCtiEmbedded: isCtiEmbedded,
        isTeamsEmbedded: isTeamsEmbedded,
        startGoogleSignIn: isCtiEmbedded ? startCtiGoogleSignIn : this.startGoogleSignIn,
        startMicrosoftSignIn: isCtiEmbedded ? startCtiMicrosoftSignIn : this.getMicrosoftSignIn(isTeamsEmbedded),
        startOidcSignIn: isCtiEmbedded ? startCtiOidcSignIn : this.startOidcSignIn,
        cancelExternalSignIn: isCtiEmbedded ? cancelCtiExternalSignIn : this.cancelExternalSignIn
      };
      return /*#__PURE__*/_jsx(SignInForm, _objectSpread({}, signInProps));
    }
  }]);
}(React.PureComponent);
_defineProperty(SignIn, "propTypes", {
  dispatch: PropTypes.func.isRequired,
  loginData: PropTypes.instanceOf(Map),
  externalSigninData: PropTypes.instanceOf(Map),
  allowedVersion: PropTypes.bool.isRequired,
  tooManyInstances: PropTypes.bool.isRequired
});
_defineProperty(SignIn, "contextType", AppContext);
var mapStateToProps = function mapStateToProps(state) {
  var app = state.app;
  var loginData = app.get('loginData', Map());
  var externalSigninData = app.get('externalSigninData', Map());
  var allowedVersion = getAllowedVersion(state);
  var tooManyInstances = hasTooManyInstances(state);
  return {
    loginData: loginData,
    externalSigninData: externalSigninData,
    allowedVersion: allowedVersion,
    tooManyInstances: tooManyInstances
  };
};
export default connect(mapStateToProps)(SignIn);